import { useCallback } from 'react';
import useResponsive from '@hooks/useResponsive';

const useMediaQueryKey = () => {
  const { isMobile, isTablet } = useResponsive();

  return useCallback((): 's' | 'm' | 'l' => {
    if (isMobile) return 's';
    return isTablet ? 'm' : 'l';
  }, [isMobile, isTablet]);
};

export default useMediaQueryKey;
